import { useState } from 'react';
import {
  ShopifyBlogArticle,
  shopifyGetBlogs,
  ShopifyGetBlogsResponse,
} from '../../../server';

type GetBlogsEffectReturn = {
  do: () => void;
  data: ShopifyBlogArticle[] | undefined;
  loading: boolean;
  success: boolean | undefined;
  error: string | undefined;
};

export const useGetBlogsEffect = (): GetBlogsEffectReturn => {
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);
  const [data, setData] = useState<ShopifyBlogArticle[] | undefined>(undefined);

  const getBlogs = (): void => {
    setLoading(true);
    shopifyGetBlogs().then((response: ShopifyGetBlogsResponse) => {
      if (response.error) {
        setError(response.error);
        setLoading(false);
        setSuccess(false);
      } else {
        setData(response.response);
        setLoading(false);
        setSuccess(true);
      }
    });
  };

  return {
    do: getBlogs,
    data,
    loading,
    success,
    error,
  };
};
